// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2uGbV","disabled":"FileBtn_disabled__wz-vT","warn":"FileBtn_warn__2GHev","fade":"FileBtn_fade__3h8M6"};